import { useAppDispatch, useAppSelector } from "../store/hooks";
import { getSeedsCostApiData } from "../slices/productcostseeds.slice";
import { RootState } from "../store";

const useSeedCosts = () => {
  const dispatch = useAppDispatch();
  const { seedsCostArray, filteredSeedsArray, loading, error } = useAppSelector(
    (state: RootState) => state.seedsdropdown
  );

  const fetchSeedCosts = (cropId: number) => {
    dispatch(getSeedsCostApiData(cropId));
  };

  return { seedsCostArray, filteredSeedsArray, loading, error, fetchSeedCosts };
};

export default useSeedCosts;
